import { Background } from 'devextreme-react/cjs/range-selector';
import React, { Component } from 'react';
import Inline from '../Inline';
import { CheckBox } from 'devextreme-react';


class RiskMatrix extends Component {
    state = {
        balanced: this.props.balanced === true,
    }

    rowStyle = {
        height: '40px',
    };

    cellStyle = {
        width: `${this.props.cellSize ?? 40}px`,
        border: '1px solid black'
    };

    cellColorsUnbalanced = [
        [2, 2, 2, 3, 3],
        [1, 1, 2, 2, 3],
        [0, 0, 1, 2, 3],
        [0, 0, 1, 1, 2],
        [0, 0, 1, 1, 2]
    ];

    cellColorsBalanced = [
        [1, 2, 2, 3, 3],
        [1, 1, 2, 2, 3],
        [0, 1, 1, 2, 2],
        [0, 0, 1, 1, 2],
        [0, 0, 0, 1, 1]
    ];

    colors = ['rgb(70,255,70)', 'yellow', 'orange', 'red'];

    render() {
        let cellSize = this.props.cellSize ?? 40;
        let ixf = [0, 1, 2, 3, 4], ixc = [0, 1, 2, 3, 4];
        let cellColors = this.state.balanced ? this.cellColorsBalanced : this.cellColorsUnbalanced;

        return (
            <div style={{ minWidth: 7 * 40 + 'px', ...this.props.style }}>
                <div style={{ display: 'flex', justifyContent: 'center', padding: '1rem' }}>
                    <CheckBox text='Balanced' value={this.state.balanced} onValueChange={e => this.setState({ balanced: this.state.balanced === false })} />
                </div>
                <div style={{ display: 'flex', alignItems: 'start' }}>
                    <div style={{
                        writingMode: 'tb-rl', transform: 'rotate(-180deg)',
                        display: 'flex',
                        justifyContent: 'center',
                        height: (cellSize * 5) + 'px',
                        fontWeight: '900'
                    }}
                    >
                        Probability
                    </div>
                    <table style={{ border: 'none', borderCollapse: 'collapse' }}>
                        {ixf.map(fi => (
                            <tr style={{ ...this.rowStyle, border: 'none' }}
                            >
                                <td style={{ ...this.cellStyle, backgroundColor: 'transparent', border: 'none' }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: '900'
                                    }}
                                    >
                                        {5 - fi}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </table>
                    <div>
                        <table style={{ border: '1px solid black', borderCollapse: 'collapse' }}>
                            {ixf.map(fi => (
                                <tr style={this.rowStyle}
                                >
                                    {ixc.map(ci => (
                                        <td style={{ ...this.cellStyle, backgroundColor: this.colors[cellColors[fi][ci]] }}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: '900'
                                            }}
                                            >
                                                {ci === this.props.ca_cat && 4 - fi === this.props.pof_cat ? 'A' : ''}
                                                {ci === this.props.cf_cat && 4 - fi === this.props.pof_cat ? 'F' : ''}
                                            </div>

                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </table>

                        <table style={{ border: 'none', borderCollapse: 'collapse' }}>
                            <tr style={{ ...this.rowStyle, verticalAlign: 'top', height: cellSize / 2 + 'px' }}
                            >
                                {ixc.map(ci => (
                                    <td style={{ ...this.cellStyle, border: 'none', backgroundColor: 'transparent', height: cellSize / 2 + 'px', paddingTop: '10px' }}>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontWeight: '900'
                                        }}
                                        >
                                            {String.fromCharCode(65 + ci)}
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        </table>
                        <div style={{ display: 'flex', justifyContent: 'center', fontWeight: '900' }}>Consequence</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default RiskMatrix;